module.exports = class Dynamic
    constructor: (@code, @dynamicable) ->



// WEBPACK FOOTER //
// ./src/dynamic.coffee